const amoEventConst = [
  // ########### Сделки
  {
    value: 'add_lead',
    label: 'Добавлена сделка',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'update_lead',
    label: 'Сделка изменена',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'note_lead',
    label: 'Примечание добавлено в сделку',
    field: [],
  },
  {
    value: 'delete_lead',
    label: 'Удалена сделка',
    field: [],
  },
  {
    value: 'status_lead',
    label: 'У сделки сменился статус',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'restore_lead',
    label: 'Сделка восстановлена из удаленных',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'responsible_lead',
    label: 'У сделки сменился ответственный',
    field: [
      { value: 'name', label: 'Название сделки' },
      { value: 'price', label: 'Бюджет сделки' },
      { value: 'status_id', label: 'Статус сделки' },
      { value: 'pipeline_id', label: 'Воронка' },
      { value: 'responsible_user_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  // ########### Контакты
  {
    value: 'add_contact',
    label: 'Добавлен контакт',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'update_contact',
    label: 'Контакт изменён',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'note_contact',
    label: 'Примечание добавлено в контакт',
    field: [],
  },
  {
    value: 'delete_contact',
    label: 'Удалён контакт',
    field: [],
  },
  {
    value: 'restore_contact',
    label: 'Контакт восстановлен из удаленных',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'responsible_contact',
    label: 'У контакта сменился ответственный',
    field: [
      { value: 'name', label: 'Название контакта' },
      { value: 'first_name', label: 'Имя контакта' },
      { value: 'last_name', label: 'Фамилия контакта' },
      { value: 'responsible_user_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  // ########### Задачи
  {
    value: 'add_task',
    label: 'Добавлена задача',
    field: [
      { value: 'responsible_user_id', label: 'Ответственный за задачу' },
      { value: 'text', label: 'Описание задачи' },
      { value: 'complete_till', label: 'Дата завершения задачи' },
    ],
  },
  {
    value: 'update_task',
    label: 'Задача изменена',
    field: [
      { value: 'responsible_user_id', label: 'Ответственный за задачу' },
      { value: 'text', label: 'Описание задачи' },
      { value: 'complete_till', label: 'Дата завершения задачи' },
    ],
  },
  {
    value: 'delete_task',
    label: 'Удалена задача',
    field: [],
  },
  {
    value: 'responsible_task',
    label: 'У задачи сменился ответственный',
    field: [
      { value: 'responsible_user_id', label: 'Ответственный за задачу' },
      { value: 'text', label: 'Описание задачи' },
      { value: 'complete_till', label: 'Дата завершения задачи' },
    ],
  },
  // ########### Компании
  //   { value: 'add_company', label: 'Добавлена компания' },
  //   { value: 'update_company', label: 'Компания изменена' },
  //   { value: 'note_company', label: 'Примечание добавлено в компанию' },
  //   { value: 'delete_company', label: 'Удалена компания' },
  //   { value: 'restore_company', label: 'Компания восстановлена из удаленных' },
  //   { value: 'responsible_company', label: 'У компании сменился ответственный' },
  // ########### Беседы
  //   { value: 'add_talk', label: 'Добавлена беседа' },
  //   { value: 'update_talk', label: 'Беседа изменена' },
  // ########### ?
  //   { value: 'add_message', label: 'add_message' },
  // ########### Покупатели
  //   { value: 'add_customer', label: 'Добавлен покупатель' },
  //   { value: 'update_customer', label: 'Покупатель изменен' },
  //   { value: 'note_customer', label: 'Примечание добавлено в покупателя' },
  //   { value: 'delete_customer', label: 'Удален покупатель' },
  //   {
  //     value: 'responsible_customer',
  //     label: 'У покупателя сменился ответственный',
  //   },
  // ########### ?
  //   { value: 'add_unsorted', label: 'add_unsorted' },
  //   { value: 'update_unsorted', label: 'update_unsorted' },
  //   { value: 'delete_unsorted', label: 'delete_unsorted' },
]

// сделка
// контакт
// беседа
// задача
// компания
// покупатель

export default amoEventConst
